const SET_VIEW_MAP = 'SET_VIEW_MAP'
const UPDATE_VIEW_MAP = 'UPDATE_VIEW_MAP'

export { SET_VIEW_MAP, UPDATE_VIEW_MAP }
